import { type App } from "vue";
import Popper from "vue3-popper";

export function usePopper(app: App): void {
  app.component("Popper", Popper);
}
